import { Typography } from "zudoku/components"
import type { APIDescriptor } from "../../types"
import { ApiCard } from "./ApiCard"

export const ProductApis = ({ apiDescriptors } : { apiDescriptors: APIDescriptor[] }) => {
    const categories = [ ...apiDescriptors.flatMap(api => api.categories ?? []).reduce((acc, category) => {
        acc.add(category.label);
        return acc;
    }, new Set<string>())];
    return (
        <>
            { categories.map((category) => {
                const categoryApis = apiDescriptors.filter((desc) => desc.categories.find((c => c.label === category)))
                return (
                    <section key={category}>
                        <Typography className="my-5">
                            <h2>{category}</h2>
                        </Typography>
                        <div className="grid grid-cols-2 gap-4 my-5">
                        { categoryApis.map(({name, description, path}) => (
                            <ApiCard
                                key={`${category}-${name}`}
                                title={name}
                                description={description}
                                path={path}
                            />
                            ))
                        }
                        </div>
                    </section>
                )})
            }
        </>
    )
}
